import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, type IShiftData } from "@/logic/api";
import { SessionContext } from "@/utility/useSession";
import { useApiWithReject } from "@/utility/utils";

export const useGetShiftData = () => {
    const { current: session } = useContext(SessionContext);
    const getShiftDataApi = useApiWithReject(api.hooks.shift.getShiftData());

    const userUuid = session?.site?.user?.uuid;
    const tenantId = session?.site?.tenant?.id;

    return useQuery<IShiftData, Error>({
        queryKey: ["shift", "data", userUuid, tenantId],
        queryFn: async () => {
            if (!session?.context) {
                throw new Error("Session context not available");
            }
            return getShiftDataApi.send(session.context, {});
        },
        enabled: !!session?.context && !!userUuid,
        staleTime: 5 * 60 * 1000,
        gcTime: 5 * 60 * 1000,
    });
};
